// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"236":"35d1bba5","513":"2d41c39c","703":"2502ef4f"}[chunkId] + ".chunk.js";
};